<template>
  <div class="lxm-form-feedback">
    <!--<lxm-nav :title="'羊宝宝和小兔兔的展览筹款'" :share="true"></lxm-nav>-->

    <div class="page">

      <div v-if="privateForm">
        <p style="padding-top: 0.71rem;">共收集了<span class="lxm-form-feedback__summary-number">{{ state.count }}</span>份反馈</p>
        <p class="private_form">该表单为“私密表单”，请联系表单创建人申请权限查看反馈详情</p>
      </div>
      <div v-else>
        <lxm-switch-search :searchPlaceholder="'姓名'"
                           @submit="searchSubmit"
                           @end="searchEnded">
          共收集了<span class="lxm-form-feedback__summary-number">{{ state.count }}</span>份反馈
        </lxm-switch-search>

        <lxm-table :heads="tableHeads"
                   :rows="tableRows"
                   :tos="tableTos"></lxm-table>
        <lxm-more v-if="state.hasMore" :loading="loading" @click="moreClicked"></lxm-more>
      </div>

    </div>

    <!--<lxm-close-notification></lxm-close-notification>-->
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  .lxm-form-feedback
    &>.page
      padding-top: 0
  .lxm-form-feedback__summary-number
    color: brand-primary
    font-size: size-big
  .private_form {
    font-size: 24px;
    color: red;
    font-weight: bold;
    text-align: center;
    margin-top: 10rem;
  }
</style>

<script>
  import LxmNav from '../common/LxmNav.vue'
  import LxmSwitchSearch from '../common/LxmSwitchSearch.vue'
  import LxmTable from '../common/LxmTable.vue'
  import LxmMore from '../common/LxmMore.vue'
  import LxmCloseNotification from '../common/LxmCloseNotification.vue'
  import * as aTypes from '../../../store/action-types'
  export default {
    components: {
      LxmNav,
      LxmSwitchSearch,
      LxmTable,
      LxmMore,
      LxmCloseNotification
    },
    data () {
      return {
        searching: false
      }
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.FORM_GET_FEEDBACK_LIST]
      },
      state () {
        return this.$store.state.form.feedback
      },
      tableHeads () {
        return [
          { type: 'text', value: '提交时间', style: 'width: 80px;' },
          { type: 'text', value: '姓名', style: 'width: 100px' },
          { type: 'text', value: '邮箱' },
          { type: 'icon', value: '...' }
        ]
      },
      tableRows () {
        return this.state.list.map(s => {
          return [
            s.time,
            s.name,
            { type: 'text', value: s.mail, style: 'word-break: break-all' },
            { type: 'icon', value: '>' }
          ]
        })
      },
      tableTos () {
        return this.state.list.map(s => {
          return {
            path: '/main/form/feedback-detail',
            query: {
              formId: this.$route.query.formId,
              formfillId: s.id
            }
          }
        })
      },
      privateForm () {
        return this.state.privateForm
      }
    },
    watch: {
      $route () {
        this.onMounted()
      }
    },
    mounted () {
      this.onMounted()
    },
    methods: {
      onMounted () {
        this.$store.dispatch(aTypes.GET_NOTIFICATION_STATUS, { type: 'formfill', id: this.$route.query.formId })
        this.$store.dispatch(aTypes.FORM_GET, this.$route.query.formId)
        this.fetchFirstPage()
      },
      moreClicked () {
        if (this.searching === false) {
          this.$store.dispatch(aTypes.FORM_GET_FEEDBACK_LIST, {
            id: this.$route.query.formId,
            page: this.state.currentPage + 1,
            append: true
          })
        } else {
          this.$store.dispatch(aTypes.FORM_GET_FEEDBACK_LIST, {
            id: this.$route.query.formId,
            searchName: this.searching,
            page: this.state.currentPage + 1,
            append: true
          })
        }
      },
      searchSubmit ({ value }) {
        this.searching = value
        this.$store.dispatch(aTypes.FORM_GET_FEEDBACK_LIST, {
          id: this.$route.query.formId,
          searchName: value,
          page: 1,
          append: false
        })
      },
      fetchFirstPage () {
        this.searching = false
        if (this.$store.state.loaded.form.feedback.id !== this.$route.query.formId) {
          this.$store.dispatch(aTypes.FORM_GET_FEEDBACK_LIST, {
            id: this.$route.query.formId,
            page: 1,
            append: false
          })
        }
      },
      searchEnded () {
        this.fetchFirstPage()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Feedback.vue?4d3e9f6c